import { render } from "./ApplicationFormsList.vue?vue&type=template&id=4dafd1c8&scoped=true"
import script from "./ApplicationFormsList.vue?vue&type=script&lang=js"
export * from "./ApplicationFormsList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4dafd1c8"

export default script